<template>
  <div>
    <Cell :required="required" is-link :title="title" :value="value || placeholder" @click="show=true"/>
    <Popup v-model="show" position="bottom" get-container="body">
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="show = false">取消</button>
        <button type="button" class="van-picker__confirm" @click="onConfirm">确认</button>
      </div>
      <div style="padding: 18px">
        <CheckboxGroup :value="val">
          <Checkbox checked-color="#FF6666"  style="padding: 6px 0" shape :key="i" v-for="(o,i) in options" :name="o" @click="clickSelect(o)">
            {{ o }}
          </Checkbox>
        </CheckboxGroup>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Popup, Cell, Checkbox, CheckboxGroup} from "vant";


export default {
  name: "SelectInput",
  props: {
    title: String,
    value: String,
    options: Array,
    required: Boolean,
    placeholder: String,
    multiple: Boolean,
  },
  data: function () {
    return {
      show: false,
      val: []
    }
  },
  methods: {
    clickSelect(o) {
      if (this.multiple) {
        let index = this.val.indexOf(o)
        if (index == -1) {
          this.val.push(o)
        } else {
          this.val.splice(index, 1)
        }
      } else {
        this.val = [o]
      }
    },
    onConfirm() {
      this.$emit('input', this.val.join(','))
      this.show = false
    }
  },
  components: {Popup, Cell, Checkbox, CheckboxGroup}
};
</script>
<style lang="scss" scoped>
.required {
  ::v-deep.van-cell__title {
    &::before {
      content: "*";
      color: #f44336;
    }
  }
}
</style>
